import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (leadId) => `${API_URL}/api/v1/event/${leadId}/note`;

const createNote = async (leadId, note, note_type_id) => {
  const url = getUrl(leadId);
  const body = {
    note: note,
    typeId: note_type_id,
    includeData: 1,
  };

  return await apiRequest(url, "post", JSON.stringify(body));
};

export default createNote;
